import React from 'react';
import { Dropdown } from 'react-bootstrap';

import { DropdownMenu, SelectDropdownWrapper } from './dropdown';

interface FilterDropdownProps<T extends string> {
  label: string;
  value: T;
  options: readonly T[];
  onChange: (value: T) => void;
  formatLabel?: (value: T) => string;
}

export function FilterDropdown<T extends string>({ label, value, options, onChange, formatLabel = (v) => v }: FilterDropdownProps<T>) {
  const handleOptionClick = (option: T) => () => onChange(option);

  return (
    <SelectDropdownWrapper>
      <Dropdown.Toggle variant="light">{label}</Dropdown.Toggle>
      <DropdownMenu>
        {options.map((option) => (
          <Dropdown.Item key={option} onClick={handleOptionClick(option)} active={value === option}>
            {formatLabel(option)}
          </Dropdown.Item>
        ))}
      </DropdownMenu>
    </SelectDropdownWrapper>
  );
}
